import { Injectable, SkipSelf } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { ApiEndPointsSettings } from '../../common/apiUrls/api-end-points-settings';
import { EnvService } from 'src/app/env.service';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { Observable } from 'rxjs/internal/Observable';
import { BehaviorSubject, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SettingService {
  private baseUrl: any;
  private baseTranUrl: any;
  private baseOrgUrl: any;
  private baseCoreUrl: any;
  private baseCustUrl: any;
  private baseUrlRole: any;
  private baseUrlUser: any;
  private baseImportExport: any;
  private baseUrlTask: any;

  openTaskTrigger = new BehaviorSubject(null);
  openFormReportTrigger = new BehaviorSubject(null);
  openMyTaskTrigger = new BehaviorSubject(null);

  constructor(private _http: HttpClient, private apiAddress: ApiEndPointsSettings,
    public env: EnvService, private constant: Constants) {
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseUrl = this.constant.SettingsPortNumber;
    else
      this.baseUrl = this.env.apiUrl + this.constant.SettingsPortNumber;

    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseTranUrl = this.constant.ManageTranscationportNumber;
    else
      this.baseTranUrl = this.env.apiUrl + this.constant.ManageTranscationportNumber;

    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseOrgUrl = this.constant.ManageOrganizationPortNumber;
    else
      this.baseOrgUrl = this.env.apiUrl + this.constant.ManageOrganizationPortNumber;

    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseCustUrl = this.constant.CustomizedGridComponentPortNumber;
    else
      this.baseCustUrl = this.env.apiUrl + this.constant.CustomizedGridComponentPortNumber;

    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseCoreUrl = this.constant.ManageCoreportNumber;
    else
      this.baseCoreUrl = this.env.apiUrl + this.constant.ManageCoreportNumber;

    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseUrlRole = this.constant.RolePortNumber;
    else
      this.baseUrlRole = this.env.apiUrl + this.constant.RolePortNumber;

    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseUrlUser = this.constant.ManageUserPortNumber;
    else
      this.baseUrlUser = this.env.apiUrl + this.constant.ManageUserPortNumber;

    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseImportExport = this.constant.ImportExport;
    else
      this.baseImportExport = this.env.apiUrl + this.constant.ImportExport;
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseUrlTask = this.constant.ManageTask;
    else
      this.baseUrlTask = this.env.apiUrl + this.constant.ManageTask;
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseUrlTask = this.constant.ManageTask;
    else
      this.baseUrlTask = this.env.apiUrl + this.constant.ManageTask;
  }


  //private baseUrl = this.env.apiUrl;
  // private baseUrl = this.env.apiUrl+this.constant.SettingsPortNumber;
  // // private baseCoreUrl = this.env.apiUrl+this.constant.ManageCoreportNumber;
  // private baseCoreUrl = this.constant.ManageCoreportNumber;

  // private baseTranUrl =this.constant.ManageTranscationportNumber;
  // //private baseTranUrl = this.env.apiUrl+this.constant.ManageTranscationportNumber;
  // private baseCustUrl = this.constant.CustomizedGridComponentPortNumber;
  // //private baseCustUrl = this.env.apiUrl+this.constant.CustomizedGridComponentPortNumber;
  // private baseOrgUrl = this.constant.ManageOrganizationPortNumber;
  //private baseOrgUrl = this.env.apiUrl+this.constant.ManageOrganizationPortNumber;

  createFolder(dataModel) {
    const apiCallingURl = this.baseUrl + this.apiAddress.addFolder;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  getFolderList(dataModel) {
    const apiCallingURl = this.baseUrl + this.apiAddress.getFolderList;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  getFolderListForTab(dataModel) {
    const apiCallingURl = this.baseCoreUrl + this.apiAddress.getFoulderFieldsForTab;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  getCustomdetails(dataModel) {
    const apiCallingURl = this.baseUrl + this.apiAddress.getFieldDetailForTab;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  getSubFolderList(dataModel) {
    const apiCallingURl = this.baseCoreUrl + this.apiAddress.getSubFolderList;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  getFieldTypeList(dataModel) {
    const apiCallingURl = this.baseUrl + this.apiAddress.getFieldTypeList;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  getRoleList(data): Observable<any> {
    const apiURL = this.baseUrlRole + this.apiAddress.roleList;
    return this._http.post(apiURL, data).pipe();
  }

  getAllFolderlist(dataModel) {
    const apiCallingURl = this.baseUrl + this.apiAddress.getFoldersList;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }


  addField(dataModel) {
    const apiCallingURl = this.baseUrl + this.apiAddress.addField;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  getAllFields(dataModel) {
    const apiCallingURl = this.baseUrl + this.apiAddress.getAllFields;
    //const apiCallingURl = this.baseUrl + this.apiAddress.getAllFolderFields;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  getAllFieldsCore(dataModel) {
    //const apiCallingURl = this.baseUrl + this.apiAddress.getAllFields;
    const apiCallingURl = this.baseCoreUrl + this.apiAddress.getAllFolderFields;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  GetAllFieldsForOpenAI(dataModel) {
    //const apiCallingURl = this.baseUrl + this.apiAddress.getAllFields;
    const apiCallingURl = this.baseCoreUrl + this.apiAddress.GetAllFieldsForOpenAI;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  getAllTagsList(dataModel) {
    //const apiCallingURl = this.baseUrl + this.apiAddress.getAllFields;
    const apiCallingURl = this.baseTranUrl + this.apiAddress.getAllTagList;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  GetAllMedicationList(dataModel) {
    //const apiCallingURl = this.baseUrl + this.apiAddress.getAllFields;
    const apiCallingURl = this.baseTranUrl + this.apiAddress.GetAllMedicationList;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  getAllTouchTypeList(dataModel) {
    //const apiCallingURl = this.baseUrl + this.apiAddress.getAllFields;
    const apiCallingURl = this.baseTranUrl + this.apiAddress.getAllTouchTypeList;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  getCustomInfoTypes(dataModel) {
    const apiCallingURl = this.baseTranUrl + this.apiAddress.getCustomInfoTypes;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  getStatusesByTouchType(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.getStatusesByTouchType;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getStatusesByCustomInfoType(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.getStatusesByCustomInfoType;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getAllZipCodeList(dataModel) {
    //const apiCallingURl = this.baseUrl + this.apiAddress.getAllFields;
    const apiCallingURl = this.baseCustUrl + this.apiAddress.getAllZipCodeList;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  getStateList(countryId) {
    const apiCallingURl = this.baseOrgUrl + this.apiAddress.getStateList;
    return this._http.post(apiCallingURl, countryId).pipe();
  }

  getCityList(stateId) {
    const apiCallingURl = this.baseOrgUrl + this.apiAddress.getCityList;
    return this._http.post(apiCallingURl, stateId).pipe();
  }

  getAllTypeList(dataModel) {
    //const apiCallingURl = this.baseUrl + this.apiAddress.getAllFields;
    const apiCallingURl = this.baseCoreUrl + this.apiAddress.getAllTypeList;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }


  deleteField(dataModel) {
    const apiCallingURl = this.baseUrl + this.apiAddress.deleteField;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  deleteFolder(dataModel) {
    const apiCallingURl = this.baseUrl + this.apiAddress.deleteFolder;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  deactivateFields(dataModel) {
    const apiCallingURl = this.baseCoreUrl + this.apiAddress.deactivateField;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  deleteGroup(dataModel) {
    const apiCallingURl = this.baseCoreUrl + this.apiAddress.deleteGroup;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  renameGroup(dataModel) {
    const apiCallingURl = this.baseCoreUrl + this.apiAddress.editGroup;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }


  createSubFolder(dataModel) {
    const apiCallingURl = this.baseCoreUrl + this.apiAddress.createSubFolder;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  getSubFolderFields(dataModel) {
    const apiCallingURl = this.baseUrl + this.apiAddress.getSubFolderFields;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  getFolderFields(dataModel) {
    const apiCallingURl = this.baseUrl + this.apiAddress.getFolderFields;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  updateField(dataModel) {
    const apiCallingURl = this.baseUrl + this.apiAddress.updateField;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  ReorderFieldPostion(dataModel) {
    const apiCallingURl = this.baseCoreUrl + this.apiAddress.ReorderFieldPosition;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  addEditGroup(dataModel) {
    const apiCallingURl = this.baseUrl + this.apiAddress.addEditGroup;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  getAllTypes(dataModel: any) {
    const apiCallingURl = this.baseUrl + this.apiAddress.getAllTypes;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  getAllTransactionRoles(dataModel: any) {
    const apiCallingURl = this.baseTranUrl + this.apiAddress.geAllTransactionRolesList;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  deleteTransactionRoles(dataModel: any) {
    const apiCallingURl = this.baseTranUrl + this.apiAddress.deleteTransactionRoles;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  getAllTags(dataModel: any) {
    const apiCallingURl = this.baseTranUrl + this.apiAddress.getAllTags;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  deleteTypes(dataModel: any) {
    const apiCallingURl = this.baseUrl + this.apiAddress.deleteTypes;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  deleteTag(dataModel: any) {
    const apiCallingURl = this.baseTranUrl + this.apiAddress.deleteTags;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  updateType(dataModel: any) {
    const apiCallingURl = this.baseUrl + this.apiAddress.updateType;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  UpdateTransactinalRole(dataModel: any) {
    const apiCallingURl = this.baseTranUrl + this.apiAddress.UpdateTransactinalRole;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  AddTransactinalRole(dataModel: any) {
    const apiCallingURl = this.baseTranUrl + this.apiAddress.UpdateTransactinalRole;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }


  checkIfTypeExists(dataModel: any) {
    const apiCallingURl = this.baseUrl + this.apiAddress.checkIfTypeExists;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  GetProjectDocumentsAndParticipantDetailsStep4(dataModel: any) {
    const apiCallingURl = this.baseTranUrl + this.apiAddress.GetProjectDocumentsAndParticipantDetailsStep4;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  FileManagerItemsWithHierarchy(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.FileManagerItemsWithHierarchy;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getFoldersListForFML(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.getFileManagerFolderList;
    return this._http.post(apiURL, reqModel).pipe();
  }

  MoveFileManagerItems(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.moveFileManagerItem;
    return this._http.post(apiURL, reqModel).pipe();
  }

  renameFileManagerItems(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.renameFileManagerItem;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetUserList(reqModel): Observable<any> {
    const apiURL = this.baseUrlUser + this.apiAddress.GetUserList;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddRequestFromCCC(reqModel, mainModuleName): Observable<any> {
    if (mainModuleName == "Core") {
      const apiURL = this.baseTranUrl + this.apiAddress.AddRequestFromCore;
      return this._http.post(apiURL, reqModel).pipe();
    }
    if (mainModuleName == "Contact") {
      const apiURL = this.baseTranUrl + this.apiAddress.AddRequestFromContact;
      return this._http.post(apiURL, reqModel).pipe();
    }
    if (mainModuleName == "Company") {
      const apiURL = this.baseTranUrl + this.apiAddress.AddRequestFromCompany;
      return this._http.post(apiURL, reqModel).pipe();
    }
  }

  AddRequestFromContact(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.AddRequestFromContact;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddRequestFromCompany(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.AddRequestFromCompany;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddFaxRequest(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.AddRequest;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddRequestFromFileManager(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.AddRequestFromCore;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetContactListCoreImplementation(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.GetContactListCoreImplementation;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetContactListFileManagerImplementation(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.GetContactListFileManagerImplementation;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetFormTemplateCategories(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.getFormTemplateCategories;
    return this._http.post(apiURL, reqModel).pipe();
  }

  ManageFormTemplateCategory(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.ManageFormTemplateCategory;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetDefaultSharingRoleSetting(reqModel): Observable<any> {
    const apiURL = this.baseUrlUser + this.apiAddress.GetDefaultSharingRoleSetting;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddEditDefaultsharingRoles(reqModel): Observable<any> {
    const apiURL = this.baseUrlUser + this.apiAddress.AddEditDefaultsharingRoles;
    return this._http.post(apiURL, reqModel).pipe();
  }
  getNormalAndSharedContacts(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.getNormalAndSharedContacts;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getNormalAndSharedCompanys(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.getNormalAndSharedCompanys;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetContactSelectedCompany(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.GetContactSelectedCompany;
    return this._http.post(apiURL, reqModel).pipe();
  }
  GetContactSelectedContact(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.GetContactSelectedContact;
    return this._http.post(apiURL, reqModel).pipe();
  }
  GetCompanySelectedContact(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.GetCompanySelectedContact;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetAllTemplatestoManage(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.GetAllTemplatestoManage;
    return this._http.post(apiURL, reqModel).pipe();
  }

  DeleteTemplate(dataModel: any) {
    const apiCallingURl = this.baseTranUrl + this.apiAddress.DeleteTemplate;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  SearchFieldName(dataModel: any) {
    const apiCallingURl = this.baseUrl + this.apiAddress.SearchFieldName;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

   SearchFieldForImport(dataModel: any) {
    const apiCallingURl = this.baseUrl + this.apiAddress.SearchFieldForImport;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  AddFieldFolderMappingForExistingField(dataModel) {
    const apiCallingURl = this.baseUrl + this.apiAddress.AddFieldFolderMappingForExistingField;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  getFormFolderList(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.getFormFolderList;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetParentFormFolderHierarchy(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.GetParentFormFolderHierarchy;
    return this._http.post(apiURL, reqModel).pipe();
  }

  MoveForm(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.moveForm;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetFieldForImportExport(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.GetFieldForImportExport;
    return this._http.post(apiURL, reqModel).pipe();
  }

   AddPreferences(reqModel): Observable<any> {
    const apiURL = this.baseOrgUrl + this.apiAddress.AddPreferences;
    return this._http.post(apiURL, reqModel).pipe();
  }

  ValidateCSV(reqModel): Observable<any> {
    const apiURL = this.baseImportExport + this.apiAddress.ValidateCSV;
    return this._http.post(apiURL, reqModel).pipe();
  }

  ImportTripleCCSV(reqModel): Observable<any> {
    const apiURL = this.baseImportExport + this.apiAddress.ImportTripleCCSV;
    return this._http.post(apiURL, reqModel).pipe();
  }

  ExportCSV(reqModel): Observable<any> {
    const apiURL = this.baseImportExport + this.apiAddress.ExportCSV;
    return this._http.post(apiURL, reqModel).pipe();
  }
  SearchSubjectTemplate(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.SearchSubjectTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddUpdateSubjectMessageTemplate(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.AddUpdateSubjectMessageTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }
  GetFormDetailsByFormID(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.GetFormDetailsByFormID;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetAllSubjectMessageTemplate(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.GetAllSubjectMessageTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetLoginDetails(reqModel): Observable<any> {
    const apiURL = this.baseOrgUrl + this.apiAddress.GetLoginDetails;
    return this._http.post(apiURL, reqModel).pipe();
  }

  DeleteSubjectMessageTemplate(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.DeleteSubjectMessageTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getSharedAccessRoles(reqModel): Observable<any> {
    const apiURL = this.baseUrlRole + this.apiAddress.getSharedAccesslRoles;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getTaskDetailByID(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.getTaskDetailByID;
    return this._http.post(apiURL, reqModel).pipe();
  }

  updateTaskDetails(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.updateTaskDetail;
    return this._http.post(apiURL, reqModel).pipe();
  }


  searchCore(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.searchCore;
    return this._http.post(apiURL, reqModel).pipe();
  }

  searchContact(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.searchContact;
    return this._http.post(apiURL, reqModel).pipe();
  }

  searchCompany(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.searchCompany;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addTaskStatus(reqModel): Observable<any> {
    const apiURL = this.baseOrgUrl + this.apiAddress.addTaskStatus;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getOfficeTaskStatus(reqModel): Observable<any> {
    const apiURL = this.baseOrgUrl + this.apiAddress.getOfficeTaskStatuses;
    return this._http.post(apiURL, reqModel).pipe();
  }

  renameTaskStatus(reqModel): Observable<any> {
    const apiURL = this.baseOrgUrl + this.apiAddress.renameTaskStatus;
    return this._http.post(apiURL, reqModel).pipe();
  }

  activateTaskStatus(reqModel): Observable<any> {
    const apiURL = this.baseOrgUrl + this.apiAddress.activateTaskStatus;
    return this._http.post(apiURL, reqModel).pipe();
  }



  getTaskTemplate(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.getTaskTemplates;
    return this._http.post(apiURL, reqModel).pipe();
  }

  renameTaskTemplate(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.renameTaskTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  activateTaskTemplate(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.activateTaskTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getTaskListFolders(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.getTaskListFolders;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getTasklistFolderSharedWithMe(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.getTasklistFolderSharedWithMe;
    return this._http.post(apiURL, reqModel).pipe();
  }

  associateTaskListFoldertoTaskTemplate(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.associateTaskListFoldertoTaskTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  SendEmailForTaskListURL(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.SendEmailForTaskListURL;
    return this._http.post(apiURL, reqModel).pipe();
  }
  SendExternalURLEmail(reqModel): Observable<any> {
    const apiURL = this.baseUrlUser + this.apiAddress.SendExternalURLEmail;
    return this._http.post(apiURL, reqModel).pipe();
  }
  GetRelationByTaskTemplateID(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.GetRelationByTaskTemplateID;
    return this._http.post(apiURL, reqModel).pipe();
  }
  addHeadertoTaskTemplate(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.addHeadertoTaskTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getImageUlpoadURL(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.getImageUploadURL;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getTaskTemplateCategories(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.getTaskTemplateCategories;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addTaskTemplateCategory(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.addTaskTemplateCategory;
    return this._http.post(apiURL, reqModel).pipe();
  }

  renameTaskTemplateCategory(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.renameTaskTemplateCategory;
    return this._http.put(apiURL, reqModel).pipe();
  }

  removeTaskTemplateCategories(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.removeTaskTemplateCategories;
    return this._http.post(apiURL, reqModel).pipe();
  }

  removeTaskTemplates(reqModel): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: reqModel
    };
    const apiURL = this.baseUrlTask + this.apiAddress.removeTaskTemplates;
    return this._http.delete(apiURL, options).pipe();
    // return this._http.delete(apiURL,reqModel).pipe();
  }

  activateTaskCategoryTemplate(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.activateTaskCategoryTemplate;
    return this._http.put(apiURL, reqModel).pipe();
  }

  addThirdPartyApi(reqModel): Observable<any> {
    const apiURL = this.baseUrlUser + this.apiAddress.addThirdPartyApi;
    return this._http.post(apiURL, reqModel).pipe();
  }


  DeleteThirdPartyApi(reqModel): Observable<any> {
    const apiURL = this.baseUrlUser + this.apiAddress.deleteThirdPartyApi;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getThirdPartyApis(reqModel): Observable<any> {
    const apiURL = this.baseUrlUser + this.apiAddress.getThirdPartyApis;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addThirdPartyApiEndpoint(reqModel): Observable<any> {
    const apiURL = this.baseUrlUser + this.apiAddress.addThirdPartyApiEndpoint;
    return this._http.post(apiURL, reqModel).pipe();
  }
  AddOfficeThirdPartyApiEndpoint(reqModel): Observable<any> {
    const apiURL = this.baseUrlUser + this.apiAddress.AddOfficeThirdPartyApiEndpoint;
    return this._http.post(apiURL, reqModel).pipe();
  }
  updateThirdPartyApiEndpoint(reqModel): Observable<any> {
    const apiURL = this.baseUrlUser + this.apiAddress.updateThirdPartyApiEndpoint;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getThirdPartyApiEndpoints(reqModel): Observable<any> {
    const apiURL = this.baseUrlUser + this.apiAddress.getThirdPartyApiEndpoints;
    return this._http.post(apiURL, reqModel).pipe();
  }
  GetFacilities(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.GetFacilities;
    return this._http.post(apiURL, reqModel).pipe();
  }
  GetOfficeAssociatedApis(reqModel): Observable<any> {
    const apiURL = this.baseUrlUser + this.apiAddress.GetOfficeAssociatedApis;
    return this._http.post(apiURL, reqModel).pipe();
  }
  getOfficeThirdPartyApiEndpoints(reqModel): Observable<any> {
    const apiURL = this.baseUrlUser + this.apiAddress.getOfficeThirdPartyApiEndpoints;
    return this._http.post(apiURL, reqModel).pipe();
  }

  deleteThirdPartyApiEndpoint(reqModel): Observable<any> {
    const apiURL = this.baseUrlUser + this.apiAddress.deleteThirdPartyApiEndpoint;
    return this._http.post(apiURL, reqModel).pipe();
  }

  // deleteOfficeThirdPartyApiEndpoint(reqModel): Observable<any> {      
  //   const apiURL = this.baseUrlUser + this.apiAddress.deleteOfficeThirdPartyApiEndpoint;  
  //   return this._http.post(apiURL,reqModel).pipe();
  // }

  deleteOfficeThirdPartyApiEndpoint(reqModel): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: reqModel
    };
    const apiURL = this.baseUrlUser + this.apiAddress.deleteOfficeThirdPartyApiEndpoint;
    return this._http.delete(apiURL, options).pipe();
  }

  addOfficeThirdPartyApi(reqModel): Observable<any> {
    const apiURL = this.baseUrlUser + this.apiAddress.addOfficeThirdPartyApi;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getOfficeThirdPartyApi(reqModel): Observable<any> {
    const apiURL = this.baseUrlUser + this.apiAddress.getOfficeThirdPartyApi;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddSuperAdminThirdPartyApi(reqModel): Observable<any> {
    const apiURL = this.baseUrlUser + this.apiAddress.AddSuperAdminThirdPartyApi;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetSuperAdminThirdPartyApi(reqModel): Observable<any> {
    const apiURL = this.baseUrlUser + this.apiAddress.GetSuperAdminThirdPartyApi;
    return this._http.post(apiURL, reqModel).pipe();
  }

  RequestClientAccessPayChex(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.RequestClientAccessPayChex;
    return this._http.post(apiURL, reqModel).pipe();
  }


  getOrganizationFormTemplateGallery(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.getOrganizationFormTemplateGallery;
    return this._http.post(apiURL, reqModel).pipe();
  }

  manageFormTemplateOrganizationCategory(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.manageFormTemplateOrganizationCategory;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addTask(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.addTask;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getTaskList(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.getTaskList;
    return this._http.post(apiURL, reqModel).pipe();
  }
  UpdateTaskStatus(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.UpdateTaskStatus;
    return this._http.post(apiURL, reqModel).pipe();
  }

  // getTaskDetailByID(reqModel): Observable<any> {         
  //   const apiURL = this.baseUrlTask + this.apiAddress.getTaskDetailByID;  
  //   return this._http.post(apiURL, reqModel).pipe();
  // } 

  getSubTasks(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.getSubTasks;
    return this._http.post(apiURL, reqModel).pipe();
  }

  removeSubTasks(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.removeSubTasks;
    return this._http.post(apiURL, reqModel).pipe();
  }

  removeTasks(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.removeTasks;
    return this._http.post(apiURL, reqModel).pipe();
  }
  SendManualTaskReminderService(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.sendManualReminderforTask;
    return this._http.post(apiURL, reqModel).pipe();
  }
  addTasklistFolder(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.addTasklistFolder;
    return this._http.post(apiURL, reqModel).pipe();
  }

  // getTaskListFolders(reqModel): Observable<any> {      
  //   const apiURL = this.baseUrlTask + this.apiAddress.getTaskListFolders;  
  //   return this._http.post(apiURL,reqModel).pipe();
  // }

  addTaskList(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.addTaskList;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getTaskLists(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.getTaskLists;
    return this._http.post(apiURL, reqModel).pipe();
  }

  renameTasklistFolder(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.renameTasklistFolder;
    return this._http.post(apiURL, reqModel).pipe();
  }

  removeTasklistFolder(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.removeTasklistFolder;
    return this._http.post(apiURL, reqModel).pipe();
  }

  renameTasklist(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.renameTasklist;
    return this._http.post(apiURL, reqModel).pipe();
  }

  removeTasklist(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.removeTasklist;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getTaskByTaskList(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.getTaskByTaskList;
    return this._http.post(apiURL, reqModel).pipe();
  }

  reorderTasksLists(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.reorderTaskList;
    return this._http.post(apiURL, reqModel).pipe();
  }

  taskMovetoTaskList(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.taskMovetoTaskList;
    return this._http.post(apiURL, reqModel).pipe();
  }

  taskStatus(reqModel): Observable<any> {
    const apiURL = this.baseOrgUrl + this.apiAddress.taskStatus;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addTaskTemplate(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.addTaskTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getTaskTemplates(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.getTaskTemplates;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getActiveTaskTemplates(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.getActiveTaskTemplates;
    return this._http.post(apiURL, reqModel).pipe();
  }


  getActiveTaskTemplateCategories(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.getActiveTaskTemplateCategories;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addCorePlaceholdersWithDocuments(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.addCorePlaceholdersWithDocuments;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addContactPlaceholdersWithDocuments(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.addContactPlaceholdersWithDocuments;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addCompanyPlaceholdersWithDocuments(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.addCompanyPlaceholdersWithDocuments;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getTaskTemplateEmailLog(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.getTaskTemplateEmailLog;
    return this._http.post(apiURL, reqModel).pipe();
  }

  resendTemplateUrltoEmail(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.resendTemplateUrltoEmail;
    return this._http.post(apiURL, reqModel).pipe();
  }

  softRemoveTaskTemplateSent(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.softRemoveTaskTemplateSent;
    return this._http.post(apiURL, reqModel).pipe();
  }

  hardRemoveTaskTemplateSent(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.hardRemoveTaskTemplateSent;
    return this._http.post(apiURL, reqModel).pipe();
  }


  extractDocumentData(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.extractDocumentData;
    return this._http.post(apiURL, reqModel).pipe();
  }

  extractDocumentDataFileManager(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.extractDocumentDataFileManager;
    return this._http.post(apiURL, reqModel).pipe();
  }

  // GetFieldForImportExport(reqModel): Observable<any> {
  //   const apiURL = this.baseUrl + this.apiAddress.GetFieldForImportExport;
  //   return this._http.post(apiURL, reqModel).pipe();
  // }


  addFormKeyAsNewFields(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.addFormKeyAsNewFields;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getSynonyms(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.getSynonyms;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addFormKeyFieldMapping(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.AddFormKeyFieldMapping;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getSingleTaskTemplates(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.getSingleTaskTemplates;
    return this._http.post(apiURL, reqModel).pipe();
  }

  importTaskFromTemplate(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.importTaskFromTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addSingleTaskTemplate(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.addSingleTaskTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addTaskListToCCCs(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.AddTaskListToCCCs;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addTasksToCCCs(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.AddTasksToCCCs;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getFormFolderWithFormTemplates(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.getFormFolderWithFormTemplates;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getFormFolderSharedWithMeList(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.getFormFolderSharedWithMe;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getFormFolderWithFormTemplatesSharedWithMe(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.getFormFolderWithFormTemplatesSharedWithMe;
    return this._http.post(apiURL, reqModel).pipe();
  }

  createProjectsforMultipleCCC(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.createProjectsforMultipleCCC;
    return this._http.post(apiURL, reqModel).pipe();
  }

  archivedTaskList(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.archivedTaskList;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getArchivedTaskLists(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.getArchivedTaskLists;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getArchivedSingleTaskLists(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.getArchivedSingleTaskLists;
    return this._http.post(apiURL, reqModel).pipe();
  }

  archivedTask(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.archivedTask;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetTaskGroupsByTaskList(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.GetTaskGroupsByTaskList;
    return this._http.post(apiURL, reqModel).pipe();
  }

  removeSingleTaskTemplates(reqModel): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: reqModel
    };
    const apiURL = this.baseUrlTask + this.apiAddress.removeSingleTaskTemplates;
    return this._http.delete(apiURL, options).pipe();
    // return this._http.delete(apiURL,reqModel).pipe();
  }


  renameSingleTaskTemplate(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.renameSingleTaskTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  activeSingleTaskTemplate(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.activeSingleTaskTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  searchFieldName(reqModel): Observable<any> {
    const apiURL = this.baseCoreUrl + this.apiAddress.searchFieldName;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getOffices(reqVM) {
    const apiCallingURl = this.baseOrgUrl + this.apiAddress.getOffices;
    return this._http.post(apiCallingURl, reqVM).pipe();
  }

  move3CtoAnotherOffice(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.move3CtoAnotherOffice;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getCoreList(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.getCoreListing;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getContactList(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.getContactListing;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getCompanyList(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.getCompanyListing;
    return this._http.post(apiURL, reqModel).pipe();
  }

  updateCoreFieldColumnList(reqModel): Observable<any> {
    const apiURL = this.baseCustUrl + this.apiAddress.updateCoreFieldColumn;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getTouchTypeAndStatusess(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.getTouchTypeAndStatusess;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getCustomInfoTypeAndStatuses(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.getCustomInfoTypeAndStatuses;
    return this._http.post(apiURL, reqModel).pipe();
  }

  removeTouchStatus(reqModel): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: reqModel
    };
    const apiURL = this.baseTranUrl + this.apiAddress.removeTouchStatus;
    return this._http.delete(apiURL, options).pipe();
  }

  removeCustomInfoStatus(reqModel): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: reqModel
    };
    const apiURL = this.baseTranUrl + this.apiAddress.removeCustomInfoStatus;
    return this._http.delete(apiURL, options).pipe();
  }

  getOCRTemplateCategories(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.getOCRTemplateCategories;
    return this._http.post(apiURL, reqModel).pipe();
  }

  renameOCRTemplateCategory(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.renameOCRTemplateCategory;
    return this._http.post(apiURL, reqModel).pipe();
  }

  activateOCRCategoryTemplate(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.activateOCRCategoryTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  removeOCRTemplateCategories(reqModel): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: reqModel
    };
    const apiURL = this.baseTranUrl + this.apiAddress.removeOCRTemplateCategories;
    return this._http.delete(apiURL, options).pipe();
  }

  GetOCRTemplates(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.GetOCRTemplates;
    return this._http.post(apiURL, reqModel).pipe();
  }

  UpdateNTAJsonInBlob(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.UpdateNTAJsonInBlob;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetNTAJsonFromBlob(): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.GetNTAJsonFromBlob;
    return this._http.get(apiURL).pipe();
  }

  renameOCRTemplate(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.renameOCRTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  activateOCRTemplate(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.activateOCRTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  removeOCRTemplates(reqModel): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: reqModel
    };
    const apiURL = this.baseTranUrl + this.apiAddress.removeOCRTemplates;
    return this._http.delete(apiURL, options).pipe();
  }


  updateFieldDefaultSynonyms(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.updateFieldDefaultSynonyms;
    return this._http.post(apiURL, reqModel).pipe();
  }

  updateFieldSynonyms(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.updateFieldSynonyms;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addEditEmailTemplate(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.addEditEmailTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getAllEmailTemplates(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.getAllEmailTemplates;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddUpdateSystemPrompts(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.AddUpdateSystemPrompts;
    return this._http.post(apiURL, reqModel).pipe();
  }

  DeleteSystemPrompt(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.DeleteSystemPrompt;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetAllSystemPrompt(): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.GetAllSystemPrompt;
    return this._http.get(apiURL).pipe();
  }

  GetSystemPromptByID(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.GetSystemPromptByID;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getEmailTemplateDetail(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.getEmailTemplateDetail;
    return this._http.post(apiURL, reqModel).pipe();
  }
  deleteEmailTemplate(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.deleteEmailTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getOfficeMailConfigration(reqModel): Observable<any> {
    const apiURL = this.baseOrgUrl + this.apiAddress.getOfficeMailConfigration;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getActivityEMails(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.getActivityEMails;
    return this._http.post(apiURL, reqModel).pipe();
  }

  get3CBroadcastMessages(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.get3CBroadcastMessages;
    return this._http.post(apiURL, reqModel).pipe();
  }

  removeActivityEmail(reqModel): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: reqModel
    };
    const apiURL = this.baseTranUrl + this.apiAddress.removeActivityEmail;
    return this._http.delete(apiURL, options).pipe();
  }

  getNLPTemplateCategories(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.getNLPTemplateCategories;
    return this._http.post(apiURL, reqModel).pipe();
  }

  renameNLPTemplateCategory(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.renameNLPTemplateCategory;
    return this._http.post(apiURL, reqModel).pipe();
  }

  activateNLPCategoryTemplate(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.activateNLPCategoryTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  removeNLPTemplateCategories(reqModel): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: reqModel
    };
    const apiURL = this.baseTranUrl + this.apiAddress.removeNLPTemplateCategories;
    return this._http.delete(apiURL, options).pipe();
  }

  getNLPTemplates(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.getNLPTemplates;
    return this._http.post(apiURL, reqModel).pipe();
  }


  renameNLPTemplate(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.renameNLPTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  activateNLPTemplate(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.activateNLPTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  removeNLPTemplates(reqModel): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: reqModel
    };
    const apiURL = this.baseTranUrl + this.apiAddress.removeNLPTemplates;
    return this._http.delete(apiURL, options).pipe();
  }


  sendFilemanagerDocuments(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.sendFilemanagerDocuments;
    return this._http.post(apiURL, reqModel).pipe();
  }

  resentBroadcastMessage(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.resentBroadcastMessage;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addFormReportFolder(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.addFormReportFolder;
    return this._http.post(apiURL, reqModel).pipe();
  }

  removeFormReportFolder(reqModel): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: reqModel
    };
    const apiURL = this.baseUrl + this.apiAddress.removeFormReportFolder;
    return this._http.delete(apiURL, options).pipe();
  }

  getFormReportFolders(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.getFormReportFolders;
    return this._http.post(apiURL, reqModel).pipe();
  }

  renameFormReportFolder(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.renameFormReportFolder;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addFormReportFolderMapping(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.addFormReportFolderMapping;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getFormReportFolderMappings(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.getFormReportFolderMappings;
    return this._http.post(apiURL, reqModel).pipe();
  }

  removeFormReportFolderMapping(reqModel): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: reqModel
    };
    const apiURL = this.baseUrl + this.apiAddress.removeFormReportFolderMapping;
    return this._http.delete(apiURL, options).pipe();
  }

  activateFormReportFolder(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.activateFormReportFolder;
    return this._http.post(apiURL, reqModel).pipe();
  }

  activateFormReportFolderMapping(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.activateFormReportFolderMapping;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getFormReportFolderMappingsFor3C(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.getFormReportFolderMappingsFor3C;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetAllCoreCarePeriods(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.GetAllCoreCarePeriods;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddCarePeriodPCC(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.AddCarePeriodPCC;
    return this._http.post(apiURL, reqModel).pipe();
  }

  UpdateMedicationByID(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.UpdateMedicationByID;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetMedicationByID(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.GetMedicationByID;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddMedicationPCC(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.AddMedicationPCC;
    return this._http.post(apiURL, reqModel).pipe();
  }

  reorder3CFormFolders(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.addFormReportFolderMapping;
    return this._http.post(apiURL, reqModel).pipe();
  }

  reorder3CForms(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.reorder3CForms;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getWebFormReportFor3C(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.getWebFormReportFor3C;
    return this._http.post(apiURL, reqModel).pipe();
  }

  updateFormFolderMapping(reqModel): Observable<any> {
    const apiURL = this.baseUrl + this.apiAddress.updateFormFolderMapping;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getAllCustomInfos(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.getAllCustomInfos;
    return this._http.post(apiURL, reqModel).pipe();
  }

  deleteCustomInfo(reqModel): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: reqModel
    };
    const apiURL = this.baseTranUrl + this.apiAddress.deleteCustomInfo;
    return this._http.delete(apiURL, options).pipe();
    // return this._http.delete(apiURL,reqModel).pipe();
  }

  downloadFilesInZip(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.downloadFilesInZip;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getAttachment(fileName, filePath): Observable<any> {
    const queryParam = '?fileName=' + filePath;
    const apiURL = this.baseTranUrl + this.apiAddress.getAttachment + '' + queryParam;
    return this._http.get(apiURL).pipe();
  }

  UploadDocumenttoPCC(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.UploadDocumenttoPCC;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addDocumentFileManagerTo3C(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.addDocumentFileManagerTo3C;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getCoreUserDetails(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.getCoreUserDetails;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getOCRTemplates(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.getOCRTemplates;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getAIAutomationTemplates(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.getAIAutomationTemplates;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addAIAutomationTemplate(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.addAIAutomationTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetSharedWithMeFileManager(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.GetSharedWithMeFileManager;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetSharedWithMeFileManagerWithHierarchy(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.GetSharedWithMeFileManagerWithHierarchy;
    return this._http.post(apiURL, reqModel).pipe();
  }

  ExtractTextForFileManagerListProcessIcon(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.ExtractTextForFileManagerListProcessIcon;
    return this._http.post(apiURL, reqModel).pipe();
  }

  processDocument(url: string, userId: string, officeId: string, organizationId: string, pdftext: string = ""): Observable<any> {
    const apiURL = 'https://pythondocumentchatapi-fud4a5bqduengkgk.eastus-01.azurewebsites.net/documents/process_document_url';
    //  const params = new HttpParams()
    //    .set('url', url)
    //    .set('UserID', userId)
    //    .set('OfficeID', officeId)
    //    .set('OrganizationID', organizationId)
    //    .set('pdftext', pdftext);
    const body = {
      url: url,
      UserID: userId,
      OfficeID: officeId,
      OrganizationID: organizationId,
      pdftext: pdftext
    };
    // return this._http.post(apiURL, null, { params, observe: 'response' }).pipe(
    return this._http.post(apiURL, body, { observe: 'response' }).pipe(
      map(response => {
        if (response.status === 200) {
          return { success: true, message: response.body['message'] };
        } else {
          return { success: false, message: response.body['message'] };
        }
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ success: false, message: error.message });
      })
    );
  }

  AddVectorFileID(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.AddVectorFileID;
    return this._http.post(apiURL, reqModel).pipe();
  }

  removeAutomationTemplate(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.removeAutomationTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getAIAutomationProcesses(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.getAIAutomationProcesses;
    return this._http.post(apiURL, reqModel).pipe();
  }

  reRunAutomationForAITool(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.reRunAutomationForAITool;
    return this._http.post(apiURL, reqModel).pipe();
  }

  removeAIAutomationProcess(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.removeAIAutomationProcess;
    return this._http.post(apiURL, reqModel).pipe();
  }

  CreateProjectFromFormLink(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.CreateProjectFromFormLink;
    //const apiURL = 'http://localhost:51865/' + this.apiAddress.CreateProjectFromFormLink;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddEditProjectGroupRelationParticipant(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.AddEditProjectGroupRelationParticipant;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddCreateProjectforPlaceholder(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.AddCreateProjectforPlaceholder;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddProjectInfoAsTemplete(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.AddProjectInfoAsTemplete;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddProjectEventLog(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.AddProjectEventLog;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetGroupList(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.GetGroupList;
    return this._http.post(apiURL, reqModel).pipe();
  }

  resetTaskProject(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.resetTaskProject;
    return this._http.put(apiURL, reqModel).pipe();
  }

  removeSignature(reqModel): Observable<any> {
    const apiURL = this.baseUrlUser + this.apiAddress.removeSignature;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getSignaturesAndInitials(reqModel): Observable<any> {
    const apiURL = this.baseUrlUser + this.apiAddress.getSignaturesAndInitial;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addDefaultSignature(reqModel): Observable<any> {
    const apiURL = this.baseUrlUser + this.apiAddress.addDefaultSignature;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addSignature(reqModel): Observable<any> {
    const apiURL = this.baseUrlUser + this.apiAddress.addSignature;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getTypeOfParticipant(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.getTypeOfParticipants;
    return this._http.post(apiURL, reqModel).pipe();
  }

  resendTasklistURL (reqModel): Observable<any> {      
      const apiURL = this.baseUrlTask + this.apiAddress.resendTasklistURL;  
      return this._http.post(apiURL,reqModel).pipe();
    }
    
    addEditTaskGroup(reqModel): Observable<any> {      
        const apiURL = this.baseUrlTask + this.apiAddress.addEditTaskGroup;  
        return this._http.post(apiURL,reqModel).pipe();
      }

   makeTaskRequired(reqModel): Observable<any> {         
    const apiURL = this.baseUrlTask + this.apiAddress.makeTaskRequired;  
    return this._http.post(apiURL, reqModel).pipe();
   } 

      
    getDashboardFolderTasklists(reqModel): Observable<any> {
      const apiURL = this.baseUrlTask + this.apiAddress.getDashboardFolderTasklists;
      return this._http.post(apiURL, reqModel).pipe();
    }

    aIAutomationRunManuallyForFile(reqModel): Observable<any> {
      const apiURL = this.baseTranUrl + this.apiAddress.aIAutomationRunManuallyForFile;
      return this._http.post(apiURL, reqModel).pipe();
    }
    
   reorderTaskGroup(reqModel): Observable<any> {      
    const apiURL = this.baseUrlTask + this.apiAddress.reorderTaskGroup;  
    return this._http.post(apiURL,reqModel).pipe();
  }

   removeTaskGroup(reqModel): Observable<any> {      
    const apiURL = this.baseUrlTask + this.apiAddress.removeTaskGroup;  
    return this._http.post(apiURL,reqModel).pipe();
  }

   importSelectedFieldsForOtherOffices(reqModel): Observable<any> {
    const apiURL = this.baseOrgUrl + this.apiAddress.importSelectedFieldsForOtherOffices;
    return this._http.post(apiURL, reqModel).pipe();
  }

  
   setDefualtDocumentTemplate(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.setDefualtDocumentTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  renameDocumentTemplate(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.renameDocumentTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  reorderDocumentTemplate(reqModel): Observable<any> {
    const apiURL = this.baseTranUrl + this.apiAddress.reorderDocumentTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

}
